import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-oauth2-success',
  templateUrl: './oauth2-success.component.html',
  styleUrls: ['./oauth2-success.component.css']
})
export class Oauth2SuccessComponent implements OnInit {

  successMessage!: string | null;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.successMessage = this.route.snapshot.paramMap.get("message");
  }

}
